import Vue from 'vue';
import VideoComponent from '@app/components/Video.vue';
export default Vue.extend({
    components: {
        VideoComponent: VideoComponent
    },
    props: {
        block: Object
    },
    computed: {
        logo: function () {
            return this.$helpers.taggedFirst(this.block.images, 'logo');
        }
    }
});
